<template>
  <div class="chart-echarts-box" id="box">
    <div class="chart-echarts" id="ranking_gauge_chart1"></div>
    <div class="chart-echarts" id="ranking_gauge_chart2"></div>
  </div>
</template>
<script>
import * as echarts from 'echarts'
export default {
  props: {
    scoreArray: Array,
    questionsetScore: String,
    myScore: String,
  },

  data() {
    return {
      isInitCanvas: false,
      canvasSplitLine: {
        lineStyle: {
          type: 'dashed',
          color: '#EBECF0',
          opacity: 0.8,
        },
      },
      currentBrandColor: {},
    }
  },
  mounted() {
    let screenWidth = document.querySelector('#box').clientWidth
    let boxHeight = (screenWidth / 300) * 230
    document.querySelector('#box').style.height = boxHeight + 'px'

    this.currentBrandColor = this.getCurrentBrandColor()
    console.log(this.currentBrandColor)

    this.startDrawCanvas(this.scoreArray, this.questionsetScore, this.myScore)
  },
  methods: {
    computeCanvasGrid(data) {
      const canvasGrid = {
        left: 5,
        right: 10,
        top: 38,
        bottom: 30,
      }
      let myIndex = 0
      data.forEach((item, index) => {
        if (item[1] > 0) {
          myIndex = index
        }
      })
      if (myIndex === 0) {
        canvasGrid.left += 25
      }
      if (myIndex === data.length - 1) {
        canvasGrid.right += 25
      }
      return canvasGrid
    },
    // 绘画canvas
    drawCanvas1(canvasData) {
      let xAxis = canvasData.scores
      let data = canvasData.lineDots1
      let data2 = canvasData.lineDots2
      const mainColorRgba = this.currentBrandColor.mainColorRgba
      const option = {
        xAxis: {
          boundaryGap: false,
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          splitLine: this.canvasSplitLine,
          axisLabel: {
            show: false,
          },
          splitNumber: xAxis.length,
        },
        yAxis: {
          show: false,
        },
        grid: this.computeCanvasGrid(data2),
        series: [
          {
            type: 'line',
            symbol: 'circle',
            smooth: true,
            itemStyle: {
              color: `rgba(${mainColorRgba},0.09)`,
            },

            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 1,
                  color: `rgba(${mainColorRgba},0.07)`,
                },
              ]),
            },
            data: data,
          },

          {
            type: 'line',
            smooth: true,
            symbol: 'circle',
            itemStyle: {
              color: `rgba(${mainColorRgba},1)`,
            },

            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 1,
                  color: `rgba(${mainColorRgba},0.2)`,
                },
              ]),
            },
            markPoint: {
              data: [
                {
                  type: 'max',
                },
              ],
              symbol: 'image://' + this.getCurrentBrand.imageEstimateReportMarkPoint,
              symbolSize: [52, 24],
              symbolOffset: [0, '-24px'],
              label: {
                color: '#fff',
                formatter: canvasData.myScore + '分',
                offset: [0, -2],
              },
              itemStyle: {
                borderWidth: 0,
                color: 'rgba(255,255,255,0)',
              },
            },
            data: data2,
            label: {
              formatter: function (item) {
                return item
              },
            },
          },
        ],
      }

      var rankingGaugeChartDom = document.getElementById('ranking_gauge_chart1')
      var rankingGaugeChartDom = echarts.init(rankingGaugeChartDom)
      rankingGaugeChartDom.setOption(option)
    },

    drawCanvas2(canvasData) {
      let xAxis = canvasData.scores
      const option = {
        xAxis: {
          boundaryGap: false,
          data: xAxis,
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          splitLine: {
            show: false,
          },
          axisLabel: {
            show: true,
            color: '#919499',
            margin: 12,
          },
        },
        yAxis: {
          show: false,
        },
        grid: this.computeCanvasGrid(canvasData.lineDots2),
      }

      var rankingGaugeChartDom = document.getElementById('ranking_gauge_chart2')
      var rankingGaugeChartDom = echarts.init(rankingGaugeChartDom)
      rankingGaugeChartDom.setOption(option)
    },
    // 开始绘画canvas
    startDrawCanvas(scoreArray, questionsetScore, myScore) {
      if (this.isInitCanvas) {
        return false
      }
      this.isInitCanvas = true
      // console.log('=======================');
      // console.log(arguments);
      let scoresPeoples = this.getScoresPeoples(scoreArray, questionsetScore, myScore)
      const canvasData = this.initCanvasData(
        scoresPeoples.scores,
        scoresPeoples.peoples,
        scoresPeoples.myScore
      )
      this.drawCanvas1(canvasData)
      this.drawCanvas2(canvasData)
    },
    getScoresPeoples(datas, maxScore, myScore) {
      let sortDatas = getSortDatas(datas)
      let splitArray = getSplitArray(maxScore)
      let peoples = getSplitArrayNumberCensus(sortDatas, splitArray)
      let scores = updatePeoplesLastNumber(
        Math.max(
          ...sortDatas.map((item) => {
            return item.score
          })
        )
      )
      function getSplitArrayNumberCensus(datas2, splits) {
        let result = new Array(splits.length).fill(0)
        let resultIndex = 0
        datas2.forEach(function (item, index) {
          let score = item.score
          if (score >= splits[resultIndex + 1]) {
            splits.forEach((item) => {
              if (score >= splits[resultIndex + 1]) {
                resultIndex++
                if (resultIndex >= splits.length - 1) {
                  resultIndex = splits.length - 1
                }
              }
            })
          }
          result[resultIndex] += item.number
        })
        return result
      }
      function getSplitArray(score) {
        let num = Math.ceil(parseFloat(score))
        let remainder = num % 10
        if (remainder > 0) {
          num += 10 - remainder
        }
        let result = new Array(num / 10).fill(0)

        result = result.map((item, index) => {
          return (index + 1) * 10
        })
        result.unshift(0)
        return result
      }

      // 更新分段数组最后一个值
      function updatePeoplesLastNumber(max) {
        let number = splitArray.pop()
        if (max > number) {
          splitArray.push(max)
        } else {
          splitArray.push(number)
        }
        return splitArray
      }

      // 获取排序数组
      function getSortDatas(arr) {
        return arr
          .map(function (item) {
            item.score = parseFloat(item.score)
            item.number = parseInt(item.number)
            return item
          })
          .sort(function (a, b) {
            return a.score - b.score
          })
      }
      return { scores, peoples, myScore }
    },

    // 初始化canvas数据  scores x轴   peoples y轴
    initCanvasData(scores, peoples, my_score) {
      const myScore = parseFloat(my_score)

      let maxScore = 0 //最大分数
      let minPeople = 0 // 最小人数
      let maxPeople = 0 //最多人数
      let lineDots1 = []
      let lineDots2 = []
      function getLineDots1() {
        let result = []
        peoples.forEach((item, index) => {
          result.push([scores[index], item])
        })
        return result
      }

      function getLineDots2(list) {
        let array = JSON.parse(JSON.stringify(scores))

        // array.push(myScore)
        // array.sort((a, b) => a - b)
        const result = array.map((value, index) => {
          let next = array[index + 1] || 0
          let arr = [value, 0]

          if (myScore >= value && myScore < next) {
            arr[1] = maxPeople
          }

          if (index === array.length - 1) {
            if (myScore >= value) {
              arr[1] = maxPeople
            }
          }
          return arr
        })
        return result
      }

      function init() {
        scores = scores.map((item) => parseFloat(item))
        peoples = peoples.map((item) => parseInt(item))
        maxScore = Math.max(...scores)
        minPeople = Math.min(...peoples)
        maxPeople = Math.max(...peoples)
        lineDots1 = getLineDots1()
        lineDots2 = getLineDots2(JSON.parse(JSON.stringify(lineDots1)))
      }

      init()
      return {
        lineDots1,
        lineDots2,
        maxScore,
        myScore,
        scores,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.chart-echarts-box {
  position: relative;
  /* width: 300px; */
  width: 100%;
  height: 300px;
  overflow: hidden;
}

.chart-echarts-box .chart-echarts {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
